import { Path } from '@/main/router/routerPath';

import { ZarazeniPov } from './zarazeniPov';
import { PopisPneu } from './popisPneu';
import { ModelOv } from './modelOv';
import { SkladOV } from './skladOV';
import { PopisMotoru } from './popisMotoru';

export const router = new Path('Ojetevozy').addChildren([
	ZarazeniPov.router,
	PopisPneu.router,
	ModelOv.router,
	SkladOV.router,
	PopisMotoru.router,
]);
